import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";

import { MiddlePanelConstant } from "../../constants";
import { TOOLTIP_DELAY_TIME } from '../../../SpockViewPage/constants';
import { SHOW_TOOLTIP } from '../../../../components/Tooltip/constants';
import UserMiniProfile from '../../../../components/UserMiniProfile';
import UserImage from '../../../../components/UserImage/index';
import { selectUserById } from '@/common/slice/userList';

const renderLogHead = (data) => {
    let logHeadText;
    if (data.OldValue) {
        logHeadText = MiddlePanelConstant.Log.ChangedText;
    } else if (data.Field == 'Activity' || data.Field == 'Workkard') {  
        logHeadText = MiddlePanelConstant.Log.CreatedText;
    } else {
        logHeadText = MiddlePanelConstant.Log.AddedText;
    }

    return <>{data.Field} {logHeadText}</>;
};

const LogCell = ({ data }) => {    
    const dispatch = useDispatch();
    const reduxUser = useSelector(selectUserById(data?.KeyObject?.UserId));
    const timeOut = React.useRef(null);

    // open mini profile when click  on user name
    const openMiniProfile = (targetRect) => {
        const userId = data.KeyObject.UserId;
        if (userId) {
            dispatch({
                type: SHOW_TOOLTIP,
                payload: {
                    delay: TOOLTIP_DELAY_TIME,
                    target: targetRect,
                    childComponent: <UserMiniProfile userId={userId}/>,
                },
            });
        }
    };

    const onMouseEnter = (e) => {
        const targetRect = e.currentTarget.getBoundingClientRect();
        timeOut.current = setTimeout(() => openMiniProfile(targetRect), 500);
    };

    const onMouseLeave = () => {
        clearTimeout(timeOut.current);
    };

    const firstName = reduxUser?.first_name || data.KeyObject.FirstName || '';
    const lastName = reduxUser?.last_name || data.KeyObject.LastName || '';
    const isUserActive = reduxUser?.is_active;
    const createdTime = (data.KeyObject.CreatedDateString || '').split('at')[1];
    const uniqueLogItems = data.Data.filter((item, index, items) =>
        index === items.findIndex((other) =>
            other.Id === item.Id &&
            other.Field === item.Field &&
            other.OldValue === item.OldValue &&
            other.NewValue === item.NewValue
        )
    );

    return(
        <div className="logListing detailListing" key={data.KeyObject.Id} >
            <div className="logCreatedDate detailCreatedDate" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                 <UserImage profileUrl={data.KeyObject.ProfileImage} className="profilePic" profileName={`${firstName} ${lastName}`}/>
            </div>
            <div className="logRightBlock detailRightBlock">
                <div className="logDescription detailDescription">
                    <div className="rowSpaceBetween mb">
                        <span className="userInfo alignMiddle">
                            {firstName} {lastName} 
                            {!isUserActive && ( <span className="gray"> (Inactive)</span>)}
                            <span className="dateTime"><label className="mrNone">{createdTime}</label></span>
                        </span>
                    </div>
                    {
                        uniqueLogItems.map((item,key)=>{
                            return(
                                <div className="col-2 rowFlex" key={key}>
                                    <div>
                                        <span className="mb__8">{ renderLogHead(item) } {MiddlePanelConstant.From}</span>
                                        <p className="label">{item.OldValue || "-"}</p>
                                    </div>
                                    <div>
                                        <span className="mb__8">{MiddlePanelConstant.To}</span>
                                        <p className="">{item.NewValue || "-"}</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default LogCell;
